import React from 'react';

/**
 * Outbound-link arrow from the marketing design system: 12x12, 1.1 stroke,
 * pointing up and to the right. Marks a link that leaves the page it is on.
 */
export function ArrowOutIcon({ className }: { className?: string }): React.ReactElement {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 12 12"
      stroke="currentColor"
      strokeWidth="1.1"
      aria-hidden="true"
    >
      <path d="M3 9l6-6M4 3h5v5" />
    </svg>
  );
}
